import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useUserProvider } from "../context/UserProvider";

import { ColorModeContext } from "../context/ColorModeProvider";

import { toast } from "react-toastify"; // then this

import {
  CssBaseline,
  Container,
  Typography,
  Button,
  TextField,
  Grid,
  Card,
  Stack,
} from "@mui/material";

const SignIn = () => {
  const { theme } = useContext(ColorModeContext);

  const [email, setEmail] = useState("");
  const { resetPassword } = useUserProvider();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      try {
        await resetPassword(email);

        // Alert.success("Plzz Check your Inbox for further instructions", 2000);
        toast.success("Plzz Check your Inbox for further instructions", {
          theme: "colored",
        });

        setEmail("");
      } catch (error) {
        // Alert.error(error.message, 3000);
        toast.error(`${error.message}`, {
          theme: "colored",
        });
      }
    } else {
      // Alert.error("Fields are empty", 3000);
      toast.error("Fields are empty", {
        theme: "colored",
      });
    }
  };
  return (
    <Container size="sm">
      <CssBaseline />

      <Grid
        container
        spacing={0}
        // style={{ minWidth: "600px" }}
        style={{
          minHeight: "100vh",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            color={theme.palette.mode === "dark" ? "#fff" : "#254c73"}
            component="h2"
            gutterBottom
          >
            Forgot Password
          </Typography>

          <Card sx={{ pl: 4, pr: 4, pt: 5, pb: 5 }}>
            <form onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  value={email}
                  label="Email"
                  // onChange={(e) => setEmail(e)}
                  onChange={(e) => setEmail(e.target.value)}
                  name="name"
                  t
                />
              </Stack>

              <Stack
                direction="row"
                mt={2}
                spacing={2}
                justifyContent="space-between"
              >
                <Typography sx={{ pt: 0.5, pb: 0.5, pl: 1 }} fontSize="small">
                  <Link
                    style={{
                      color:
                        theme.palette.mode === "dark" ? "#00bfc6" : "#00bfc6",
                      textDecoration: "none",
                    }}
                    to="/login"
                  >
                    Log in
                  </Link>
                </Typography>
                <Typography sx={{ pt: 0.5, pb: 0.5, pr: 1 }} fontSize="small">
                  <Link
                    style={{
                      color:
                        theme.palette.mode === "dark" ? "#00bfc6" : "#00bfc6",
                      textDecoration: "none",
                    }}
                    to="/signup"
                  >
                    Register
                  </Link>
                </Typography>
              </Stack>

              <Stack direction="row" mt={2} spacing={2}>
                <Button variant="contained" type="submit">
                  Reset Password
                </Button>
              </Stack>
            </form>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SignIn;
